import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_ORIGIN = 'https://kikakugoke.com';

/**
 * ページの canonical URL を動的に設定するフック。
 * index.html の既定値（サイトトップ）を、ページ固有の URL で上書きする。
 *
 * 使用例:
 *   useCanonicalUrl('https://kikakugoke.com/blog/kanji-mendo');
 */
export function useCanonicalUrl(url: string | undefined): void {
  useEffect(() => {
    if (!url) return;
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const previous = link?.getAttribute('href') ?? null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = url;

    return () => {
      if (previous && link) {
        link.href = previous;
      }
    };
  }, [url]);
}

/**
 * 現在の pathname から canonical URL を自動生成して設定するフック。
 * MainLayout で 1 回呼び出すだけで全ページに適用される。
 * クエリ文字列・ハッシュは正規化のため除外し、末尾スラッシュも除去する（トップ `/` を除く）。
 */
export function useAutoCanonical(): void {
  const { pathname } = useLocation();
  const normalizedPath =
    pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
  const url =
    normalizedPath === '/'
      ? SITE_ORIGIN
      : `${SITE_ORIGIN}${normalizedPath}`;
  useCanonicalUrl(url);
}
